import Vue from 'vue'
import Router from 'vue-router'
import BaseRouter from './base.router'
import BusRouter from './business.router'

Vue.use(Router)

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export const ALL_ROUTER = [...BaseRouter, ...BusRouter]
export default new Router({
  base: '/pc/',
  routes: ALL_ROUTER,
  scrollBehavior(to, from, savedPosition) {
    window.scroll(0, 0)
    document.body.scrollTop=0
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js